var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-container"},[_vm._l((_vm.homes),function(item){return (_vm.homes.length>0)?_c('div',{staticClass:"tab-items"},[[_c('div',[_c(item.htmlContent,{tag:"component",attrs:{"item":item}})],1)]],2):_vm._e()}),(_vm.kfUrl)?_c('div',{staticClass:"kefu",on:{"click":_vm.toKF}},[_c('i',{staticClass:"el-icon-headset"})]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }